const signUpPending = 'SIGN_UP_PENDING';

export default {
  signUpPending,
};
